export const formatDateToYYYYMMDD = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const formatDateForCalendly = (date: string, time: string): string => {
  const dateObj = new Date(date);
  const timeObj = new Date(time);
  
  const year = dateObj.getFullYear();
  const month = String(dateObj.getMonth() + 1).padStart(2, '0');
  const day = String(dateObj.getDate()).padStart(2, '0');
  const hours = String(timeObj.getHours()).padStart(2, '0');
  const minutes = String(timeObj.getMinutes()).padStart(2, '0');
  
  return `${year}-${month}-${day}T${hours}:${minutes}:00`;
};

export const formatPhoneNumber = (phone: string): string => {
  // Remove all non-digit characters
  const cleaned = phone.replace(/\D/g, '');
  
  // Format as Italian phone number
  if (cleaned.length === 10) {
    return `+39${cleaned}`;
  } else if (cleaned.startsWith('39') && cleaned.length === 11) {
    return `+${cleaned}`;
  } else if (cleaned.startsWith('+39')) {
    return cleaned;
  }
  
  return phone; // Return original if can't format
}; 